"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.performance = void 0;
exports.flattenKeys = flattenKeys;
exports.applyMixins = applyMixins;
exports.timer = timer;
exports.getAdapterDefaultValues = getAdapterDefaultValues;
exports.getAdapterHiddenFields = getAdapterHiddenFields;
const isObject_1 = __importDefault(require("lodash/isObject"));
const reduce_1 = __importDefault(require("lodash/reduce"));
const merge_1 = __importDefault(require("lodash/merge"));
function flattenKeys(obj, path = []) {
    return !(0, isObject_1.default)(obj) || obj instanceof Date
        ? { [path.join('.')]: obj }
        : (0, reduce_1.default)(obj, (cum, next, key) => {
            return (0, merge_1.default)(cum, flattenKeys(next, [...path, key]));
        }, {});
}
function applyMixins(derivedCtor, baseCtors) {
    baseCtors.forEach(baseCtor => {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach(name => {
            Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name));
        });
    });
}
exports.performance = {
    now(start) {
        if (!start)
            return process.hrtime();
        var end = process.hrtime(start);
        return Math.round(end[0] * 1000 + end[1] / 1000000);
    },
    time(start, end) { },
};
function timer(startOnCreate = false) {
    let start = startOnCreate ? exports.performance.now() : undefined;
    let end;
    return {
        start() {
            if (start) {
                throw new Error('Can only start a timer once');
            }
            start = exports.performance.now();
        },
        stop() {
            if (!start) {
                throw new Error('Cannot call end before started');
            }
            end = exports.performance.now(start);
        },
        time() {
            return end;
        },
    };
}
function getAdapterDefaultValues(type) {
    switch (type) {
        case 'mysql':
            return {
                port: 3306,
            };
        case 'postgresql':
            return {
                port: 5432,
            };
        case 'mssql':
            return {
                port: 1433,
            };
        case 'mongodb':
            return {
                port: 27017,
            };
        case 'oracle':
            return {
                port: 1521,
            };
        case 'db2':
            return {
                port: 50000,
            };
        case 'csv':
            return {
                delimiter: ',',
                encoding: 'utf8',
                hasHeader: true,
            };
        case 'cobol':
            return {
                encoding: 'ebcdic',
                codepage: 'cp037',
            };
        case 'aison-record':
            return {
                link: false,
                batch: true,
            };
        case 'aison-application':
        default:
            return {};
    }
}
function getAdapterHiddenFields(type) {
    switch (type) {
        case 'mysql':
        case 'postgresql':
        case 'mssql':
            return ['password'];
        case 'aison-record':
        case 'aison-application':
            return ['sid', 'password', 'token'];
        default:
            return [];
    }
}
//# sourceMappingURL=utils.js.map